<template>
  <!-- Modal -->
  <div>
    <div class="modal fade" ref="vuemodal" id="EditPasswordModal" tabindex="-1" aria-hidden="true">
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title font-weight-bold">{{ translations('navbar.change_password') }}</h5>
            <button type="button" class="close" data-dismiss="modal">&times;</button>
          </div>
          <div class="modal-body">
            <form :class="this.wasValidated ? 'was-validated' : ''">
              <div class="form-group mb-3">
                <h6 class="font-weight-bold">{{ translations('account_setting.current_password') }}</h6>
                <input
                  type="text"
                  v-model="form.current_pw"
                  v-validate="'required'"
                  data-vv-name="current_pw"
                  data-vv-as="現在のパスワード"
                  class="form-control"
                  required
                >
                <div class="invalid-feedback">
                  {{ translations('account_setting.current_password_required') }}
                </div>
              </div>
              <div class="form-group mb-3">
                <h6 class="font-weight-bold">{{ translations('account_setting.new_password') }}</h6>
                <input
                  type="text"
                  v-model="form.new_pw"
                  v-validate="'required'"
                  data-vv-name="new_pw"
                  data-vv-as="新しいパスワード"
                  class="form-control"
                  required
                >
                <div class="invalid-feedback">
                  {{ translations('account_setting.new_password_required') }}
                </div>
              </div>
              <div class="form-group mb-3">
                <h6 class="font-weight-bold">{{ translations('account_setting.new_password_re_enter') }}</h6>
                <input
                  type="text"
                  v-model="form.confirmation_pw"
                  v-validate="'required'"
                  data-vv-name="confirmation_pw"
                  data-vv-as="新しいパスワード（再入力）"
                  class="form-control"
                  required
                >
                <div class="invalid-feedback">
                  {{ translations('account_setting.new_password_re_enter_required') }}
                </div>
              </div>
            </form>
          </div>
          <div class="modal-footer">
            <div>
              <button ref="closeEditUserModal" type="button" class="btn btn-secondary" data-dismiss="modal">{{ translations('common.close') }}</button>&nbsp;
              <button type="submit" class="btn btn-primary" v-on:click="validateBeforeUpdate">{{ translations('common.update') }}</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'EditPasswordModal',
  props: {},
  data () {
    return {
      form: {},
      wasValidated: false,
      isLoading: false
    }
  },
  created () {
  },
  mounted () {
  },
  computed: {
    ...mapState(['currentLanguage'])
  },
  methods: {
    translations (key) {
      const language = require(`@/locales/${this.currentLanguage}.json`)
      const keys = key.split('.')
      let value = language

      for (const k of keys) {
        value = value[k]
        if (!value) break
      }

      return value || key
    },
    validateBeforeUpdate: function () {
      var self = this
      self.$validator
        .validateAll()
        .then(function (response) {
          if (response === true) {
            self.updatePassword()
          }
          self.wasValidated = true
        })
        .catch(function (e) {
          // Catch errors
        })
    },
    async updatePassword () {
      var self = this
      try {
        self.isLoading = true

        let params = {
          current_pw: self.form.current_pw,
          new_pw: self.form.new_pw
        }
        let result = await this.$http.post(this.$api_url.account_change_password, params)
        if (result.data.status === true) {
          self.$toastr.info('パスワード変更が完了しました。', '完了')
          window.$('#EditPasswordModal').modal('hide')
          self.form = {}
          self.wasValidated = false
        } else {
          self.$toastr.error(result.data.message, 'エラー')
        }
        self.isLoading = false
      } catch (error) {
        self.isLoading = false
        self.$toastr.error('エラーのため失敗しました。ご確認後、再試行してください。', 'エラー')
        console.log('account:change_password:catch(error): ', error)
      }
    }
  }
}
</script>
